export default "__VITE_ASSET__B7QXp$_o__"